import getConfig from 'next/config'

const HTTPS_PROTOCOL = 'https:'
const DEFAULT_DOMAIN = 'housekeeper.com'
const { publicRuntimeConfig } = getConfig()

const { CGC_WEB_SITE_DOMAIN_OVERRIDE, CGC_WEB_GRAPHQL_URL_OVERRIDE } = publicRuntimeConfig

export function siteDomain(ctx) {
  if (CGC_WEB_SITE_DOMAIN_OVERRIDE) {
    return CGC_WEB_SITE_DOMAIN_OVERRIDE
  }

  if (!ctx) {
    return DEFAULT_DOMAIN
  }

  const req = ctx.req
  var hostname

  if (!req || !req.headers || !req.headers.host) {
    hostname = window.location.hostname
  } else {
    hostname = req && req.headers && req.headers.host && req.headers.host.split(':')[0]
  }

  const full_domain = hostname && hostname.split('.')
  if (full_domain.length < 2) {
    return DEFAULT_DOMAIN
  }

  return full_domain[full_domain.length - 2] + '.' + full_domain[full_domain.length - 1]
}

function buildGqlEndpoint(protocol, domain) {
  return protocol + '//' + domain + '/api/graphql'
}

export function gqlEndpoint(ctx, environment) {
  if (CGC_WEB_GRAPHQL_URL_OVERRIDE) {
    return CGC_WEB_GRAPHQL_URL_OVERRIDE
  }

  if (!ctx) {
    return buildGqlEndpoint(HTTPS_PROTOCOL, DEFAULT_DOMAIN)
  }

  if (process.browser) {
    return buildGqlEndpoint(window.location.protocol, window.location.host)
  }

  const req = ctx.req
  return buildGqlEndpoint(HTTPS_PROTOCOL, req.headers.host)
}
